module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation9.f039dbe9.png";